/* tslint:disable */
/* eslint-disable */
/**
 * Default API
 * All endpoints not defined under specific APIs
 *
 * The version of the OpenAPI document: Latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  CalculateInput,
  CalculateInputFromJSON,
  CalculateInputToJSON,
  CalculateRequest,
  CalculateRequestFromJSON,
  CalculateRequestToJSON,
  CalculateResult,
  CalculateResultFromJSON,
  CalculateResultToJSON,
  CalculationResult,
  CalculationResultFromJSON,
  CalculationResultToJSON,
  Election,
  ElectionFromJSON,
  ElectionToJSON,
  ForecastConversionGroups,
  ForecastConversionGroupsFromJSON,
  ForecastConversionGroupsToJSON,
  ForecastRequest,
  ForecastRequestFromJSON,
  ForecastRequestToJSON,
  ForecastResult,
  ForecastResultFromJSON,
  ForecastResultToJSON,
  Metadata,
  MetadataFromJSON,
  MetadataToJSON,
  PackageOutput,
  PackageOutputFromJSON,
  PackageOutputToJSON,
  ProposalRequestLite,
  ProposalRequestLiteFromJSON,
  ProposalRequestLiteToJSON,
  SalesPeriodResult,
  SalesPeriodResultFromJSON,
  SalesPeriodResultToJSON,
  VoteInput,
  VoteInputFromJSON,
  VoteInputToJSON,
  VoteOutput,
  VoteOutputFromJSON,
  VoteOutputToJSON,
  VoteResults,
  VoteResultsFromJSON,
  VoteResultsToJSON,
} from "../models";

export interface ApiPortalCalculatePostRequest {
  medium: string;
  calculateInput: CalculateInput;
}

export interface ApiPortalForecastPostRequest {
  medium: string;
  forecastRequest: ForecastRequest;
}

export interface ApiPortalGenerateProposalPostRequest {
  proposalRequestLite: ProposalRequestLite;
}

export interface ApiPortalPackagesGetRequest {
  medium: string;
  year: number;
  monthNumber: number;
}

export interface ApiPortalSpotlengthsGetRequest {
  medium: string;
  year: number;
}

export interface ApiPricecompareCalculateMediumPostRequest {
  medium: string;
  calculateRequest: CalculateRequest;
}

export interface ApiPricecompareMetadataMediumGetRequest {
  medium: string;
}

export interface UmbracoApiDocumentrequestSearchAdvertiserNamesGetRequest {
  search?: string;
}

export interface UmbracoApiGoudenloekivoteVotePostRequest {
  voteInput?: VoteInput;
}

export interface UmbracoBackofficeApiGoudenloekiexportGetCsvPostRequest {
  electionId?: number;
}

export interface UmbracoBackofficeApiGoudenloekiexportGetEmailCsvPostRequest {
  electionId?: number;
}

export interface UmbracoBackofficeApiGoudenloekireportGetVoteResultsGetRequest {
  electionId?: number;
}

/**
 *
 */
export class V1Api extends runtime.BaseAPI {
  /**
   */
  async apiPortalCalculatePostRaw(
    requestParameters: ApiPortalCalculatePostRequest,
  ): Promise<runtime.ApiResponse<CalculationResult>> {
    if (
      requestParameters.medium === null ||
      requestParameters.medium === undefined
    ) {
      throw new runtime.RequiredError(
        "medium",
        "Required parameter requestParameters.medium was null or undefined when calling apiPortalCalculatePost.",
      );
    }

    if (
      requestParameters.calculateInput === null ||
      requestParameters.calculateInput === undefined
    ) {
      throw new runtime.RequiredError(
        "calculateInput",
        "Required parameter requestParameters.calculateInput was null or undefined when calling apiPortalCalculatePost.",
      );
    }

    const queryParameters: any = {};

    if (requestParameters.medium !== undefined) {
      queryParameters["medium"] = requestParameters.medium;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request({
      path: `/api/portal/calculate`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: CalculateInputToJSON(requestParameters.calculateInput),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CalculationResultFromJSON(jsonValue),
    );
  }

  /**
   */
  async apiPortalCalculatePost(
    requestParameters: ApiPortalCalculatePostRequest,
  ): Promise<CalculationResult> {
    const response = await this.apiPortalCalculatePostRaw(requestParameters);
    return await response.value();
  }

  /**
   */
  async apiPortalForecastConversionGroupsGetRaw(): Promise<
    runtime.ApiResponse<ForecastConversionGroups>
  > {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request({
      path: `/api/portal/forecastConversionGroups`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ForecastConversionGroupsFromJSON(jsonValue),
    );
  }

  /**
   */
  async apiPortalForecastConversionGroupsGet(): Promise<ForecastConversionGroups> {
    const response = await this.apiPortalForecastConversionGroupsGetRaw();
    return await response.value();
  }

  /**
   */
  async apiPortalForecastPostRaw(
    requestParameters: ApiPortalForecastPostRequest,
  ): Promise<runtime.ApiResponse<ForecastResult>> {
    if (
      requestParameters.medium === null ||
      requestParameters.medium === undefined
    ) {
      throw new runtime.RequiredError(
        "medium",
        "Required parameter requestParameters.medium was null or undefined when calling apiPortalForecastPost.",
      );
    }

    if (
      requestParameters.forecastRequest === null ||
      requestParameters.forecastRequest === undefined
    ) {
      throw new runtime.RequiredError(
        "forecastRequest",
        "Required parameter requestParameters.forecastRequest was null or undefined when calling apiPortalForecastPost.",
      );
    }

    const queryParameters: any = {};

    if (requestParameters.medium !== undefined) {
      queryParameters["medium"] = requestParameters.medium;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request({
      path: `/api/portal/forecast`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: ForecastRequestToJSON(requestParameters.forecastRequest),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ForecastResultFromJSON(jsonValue),
    );
  }

  /**
   */
  async apiPortalForecastPost(
    requestParameters: ApiPortalForecastPostRequest,
  ): Promise<ForecastResult> {
    const response = await this.apiPortalForecastPostRaw(requestParameters);
    return await response.value();
  }

  /**
   */
  async apiPortalGenerateProposalPostRaw(
    requestParameters: ApiPortalGenerateProposalPostRequest,
  ): Promise<runtime.ApiResponse<void>> {
    if (
      requestParameters.proposalRequestLite === null ||
      requestParameters.proposalRequestLite === undefined
    ) {
      throw new runtime.RequiredError(
        "proposalRequestLite",
        "Required parameter requestParameters.proposalRequestLite was null or undefined when calling apiPortalGenerateProposalPost.",
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request({
      path: `/api/portal/generateProposal`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: ProposalRequestLiteToJSON(requestParameters.proposalRequestLite),
    });

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async apiPortalGenerateProposalPost(
    requestParameters: ApiPortalGenerateProposalPostRequest,
  ): Promise<void> {
    await this.apiPortalGenerateProposalPostRaw(requestParameters);
  }

  /**
   */
  async apiPortalPackagesGetRaw(
    requestParameters: ApiPortalPackagesGetRequest,
  ): Promise<runtime.ApiResponse<PackageOutput>> {
    if (
      requestParameters.medium === null ||
      requestParameters.medium === undefined
    ) {
      throw new runtime.RequiredError(
        "medium",
        "Required parameter requestParameters.medium was null or undefined when calling apiPortalPackagesGet.",
      );
    }

    if (
      requestParameters.year === null ||
      requestParameters.year === undefined
    ) {
      throw new runtime.RequiredError(
        "year",
        "Required parameter requestParameters.year was null or undefined when calling apiPortalPackagesGet.",
      );
    }

    if (
      requestParameters.monthNumber === null ||
      requestParameters.monthNumber === undefined
    ) {
      throw new runtime.RequiredError(
        "monthNumber",
        "Required parameter requestParameters.monthNumber was null or undefined when calling apiPortalPackagesGet.",
      );
    }

    const queryParameters: any = {};

    if (requestParameters.medium !== undefined) {
      queryParameters["medium"] = requestParameters.medium;
    }

    if (requestParameters.year !== undefined) {
      queryParameters["year"] = requestParameters.year;
    }

    if (requestParameters.monthNumber !== undefined) {
      queryParameters["monthNumber"] = requestParameters.monthNumber;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request({
      path: `/api/portal/packages`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PackageOutputFromJSON(jsonValue),
    );
  }

  /**
   */
  async apiPortalPackagesGet(
    requestParameters: ApiPortalPackagesGetRequest,
  ): Promise<PackageOutput> {
    const response = await this.apiPortalPackagesGetRaw(requestParameters);
    return await response.value();
  }

  /**
   */
  async apiPortalSalesPeriodGetRaw(): Promise<
    runtime.ApiResponse<Array<SalesPeriodResult>>
  > {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request({
      path: `/api/portal/salesPeriod`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(SalesPeriodResultFromJSON),
    );
  }

  /**
   */
  async apiPortalSalesPeriodGet(): Promise<Array<SalesPeriodResult>> {
    const response = await this.apiPortalSalesPeriodGetRaw();
    return await response.value();
  }

  /**
   */
  async apiPortalSpotlengthsGetRaw(
    requestParameters: ApiPortalSpotlengthsGetRequest,
  ): Promise<runtime.ApiResponse<Array<number>>> {
    if (
      requestParameters.medium === null ||
      requestParameters.medium === undefined
    ) {
      throw new runtime.RequiredError(
        "medium",
        "Required parameter requestParameters.medium was null or undefined when calling apiPortalSpotlengthsGet.",
      );
    }

    if (
      requestParameters.year === null ||
      requestParameters.year === undefined
    ) {
      throw new runtime.RequiredError(
        "year",
        "Required parameter requestParameters.year was null or undefined when calling apiPortalSpotlengthsGet.",
      );
    }

    const queryParameters: any = {};

    if (requestParameters.medium !== undefined) {
      queryParameters["medium"] = requestParameters.medium;
    }

    if (requestParameters.year !== undefined) {
      queryParameters["year"] = requestParameters.year;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request({
      path: `/api/portal/spotlengths`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   */
  async apiPortalSpotlengthsGet(
    requestParameters: ApiPortalSpotlengthsGetRequest,
  ): Promise<Array<number>> {
    const response = await this.apiPortalSpotlengthsGetRaw(requestParameters);
    return await response.value();
  }

  /**
   */
  async apiPricecompareCalculateMediumPostRaw(
    requestParameters: ApiPricecompareCalculateMediumPostRequest,
  ): Promise<runtime.ApiResponse<CalculateResult>> {
    if (
      requestParameters.medium === null ||
      requestParameters.medium === undefined
    ) {
      throw new runtime.RequiredError(
        "medium",
        "Required parameter requestParameters.medium was null or undefined when calling apiPricecompareCalculateMediumPost.",
      );
    }

    if (
      requestParameters.calculateRequest === null ||
      requestParameters.calculateRequest === undefined
    ) {
      throw new runtime.RequiredError(
        "calculateRequest",
        "Required parameter requestParameters.calculateRequest was null or undefined when calling apiPricecompareCalculateMediumPost.",
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request({
      path: `/api/pricecompare/calculate/{medium}`.replace(
        `{${"medium"}}`,
        encodeURIComponent(String(requestParameters.medium)),
      ),
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: CalculateRequestToJSON(requestParameters.calculateRequest),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CalculateResultFromJSON(jsonValue),
    );
  }

  /**
   */
  async apiPricecompareCalculateMediumPost(
    requestParameters: ApiPricecompareCalculateMediumPostRequest,
  ): Promise<CalculateResult> {
    const response =
      await this.apiPricecompareCalculateMediumPostRaw(requestParameters);
    return await response.value();
  }

  /**
   */
  async apiPricecompareMetadataMediumGetRaw(
    requestParameters: ApiPricecompareMetadataMediumGetRequest,
  ): Promise<runtime.ApiResponse<Metadata>> {
    if (
      requestParameters.medium === null ||
      requestParameters.medium === undefined
    ) {
      throw new runtime.RequiredError(
        "medium",
        "Required parameter requestParameters.medium was null or undefined when calling apiPricecompareMetadataMediumGet.",
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request({
      path: `/api/pricecompare/metadata/{medium}`.replace(
        `{${"medium"}}`,
        encodeURIComponent(String(requestParameters.medium)),
      ),
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      MetadataFromJSON(jsonValue),
    );
  }

  /**
   */
  async apiPricecompareMetadataMediumGet(
    requestParameters: ApiPricecompareMetadataMediumGetRequest,
  ): Promise<Metadata> {
    const response =
      await this.apiPricecompareMetadataMediumGetRaw(requestParameters);
    return await response.value();
  }

  /**
   */
  async sitemapXmlGetRaw(): Promise<runtime.ApiResponse<void>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request({
      path: `/sitemap.xml`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async sitemapXmlGet(): Promise<void> {
    await this.sitemapXmlGetRaw();
  }

  /**
   */
  async umbracoApiDocumentrequestSearchAdvertiserNamesGetRaw(
    requestParameters: UmbracoApiDocumentrequestSearchAdvertiserNamesGetRequest,
  ): Promise<runtime.ApiResponse<void>> {
    const queryParameters: any = {};

    if (requestParameters.search !== undefined) {
      queryParameters["search"] = requestParameters.search;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request({
      path: `/umbraco/api/documentrequest/SearchAdvertiserNames`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async umbracoApiDocumentrequestSearchAdvertiserNamesGet(
    requestParameters: UmbracoApiDocumentrequestSearchAdvertiserNamesGetRequest,
  ): Promise<void> {
    await this.umbracoApiDocumentrequestSearchAdvertiserNamesGetRaw(
      requestParameters,
    );
  }

  /**
   */
  async umbracoApiGoudenloekivoteVotePostRaw(
    requestParameters: UmbracoApiGoudenloekivoteVotePostRequest,
  ): Promise<runtime.ApiResponse<VoteOutput>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request({
      path: `/umbraco/api/goudenloekivote/Vote`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: VoteInputToJSON(requestParameters.voteInput),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      VoteOutputFromJSON(jsonValue),
    );
  }

  /**
   */
  async umbracoApiGoudenloekivoteVotePost(
    requestParameters: UmbracoApiGoudenloekivoteVotePostRequest,
  ): Promise<VoteOutput> {
    const response =
      await this.umbracoApiGoudenloekivoteVotePostRaw(requestParameters);
    return await response.value();
  }

  /**
   */
  async umbracoBackofficeApiGoudenloekiexportGetCsvPostRaw(
    requestParameters: UmbracoBackofficeApiGoudenloekiexportGetCsvPostRequest,
  ): Promise<runtime.ApiResponse<void>> {
    const queryParameters: any = {};

    if (requestParameters.electionId !== undefined) {
      queryParameters["electionId"] = requestParameters.electionId;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request({
      path: `/umbraco/backoffice/api/goudenloekiexport/GetCsv`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async umbracoBackofficeApiGoudenloekiexportGetCsvPost(
    requestParameters: UmbracoBackofficeApiGoudenloekiexportGetCsvPostRequest,
  ): Promise<void> {
    await this.umbracoBackofficeApiGoudenloekiexportGetCsvPostRaw(
      requestParameters,
    );
  }

  /**
   */
  async umbracoBackofficeApiGoudenloekiexportGetEmailCsvPostRaw(
    requestParameters: UmbracoBackofficeApiGoudenloekiexportGetEmailCsvPostRequest,
  ): Promise<runtime.ApiResponse<void>> {
    const queryParameters: any = {};

    if (requestParameters.electionId !== undefined) {
      queryParameters["electionId"] = requestParameters.electionId;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request({
      path: `/umbraco/backoffice/api/goudenloekiexport/GetEmailCsv`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async umbracoBackofficeApiGoudenloekiexportGetEmailCsvPost(
    requestParameters: UmbracoBackofficeApiGoudenloekiexportGetEmailCsvPostRequest,
  ): Promise<void> {
    await this.umbracoBackofficeApiGoudenloekiexportGetEmailCsvPostRaw(
      requestParameters,
    );
  }

  /**
   */
  async umbracoBackofficeApiGoudenloekireportGetElectionsGetRaw(): Promise<
    runtime.ApiResponse<Array<Election>>
  > {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request({
      path: `/umbraco/backoffice/api/goudenloekireport/GetElections`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(ElectionFromJSON),
    );
  }

  /**
   */
  async umbracoBackofficeApiGoudenloekireportGetElectionsGet(): Promise<
    Array<Election>
  > {
    const response =
      await this.umbracoBackofficeApiGoudenloekireportGetElectionsGetRaw();
    return await response.value();
  }

  /**
   */
  async umbracoBackofficeApiGoudenloekireportGetVoteResultsGetRaw(
    requestParameters: UmbracoBackofficeApiGoudenloekireportGetVoteResultsGetRequest,
  ): Promise<runtime.ApiResponse<VoteResults>> {
    const queryParameters: any = {};

    if (requestParameters.electionId !== undefined) {
      queryParameters["electionId"] = requestParameters.electionId;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request({
      path: `/umbraco/backoffice/api/goudenloekireport/GetVoteResults`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      VoteResultsFromJSON(jsonValue),
    );
  }

  /**
   */
  async umbracoBackofficeApiGoudenloekireportGetVoteResultsGet(
    requestParameters: UmbracoBackofficeApiGoudenloekireportGetVoteResultsGetRequest,
  ): Promise<VoteResults> {
    const response =
      await this.umbracoBackofficeApiGoudenloekireportGetVoteResultsGetRaw(
        requestParameters,
      );
    return await response.value();
  }
}
